import { useState } from "react";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";

import { Button, Label, Input } from "@/components/ui";
import {
  CreateAgreementRequestDTO,
  useCreateAgreementMutation,
  useToast,
} from "@/hooks";
import { ConvenantValidationSchema } from "@/shared";
import { DisplayError } from "@/utils";
import { ImportAgreementModal } from "./import-agreement-modal";

type FormAgreementProps = {
  handleClose: () => void;
};

export function FormCreateAgreement({ handleClose }: FormAgreementProps) {
  const { t } = useTranslation();
  const { toast } = useToast();
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);

  const initialValues = {
    name: "",
    phone: "",
    commission: "0",
  };

  const { mutateAsync, isLoading } = useCreateAgreementMutation();
  const { handleSubmit, getFieldProps, errors, touched, resetForm } = useFormik(
    {
      initialValues,
      validationSchema: ConvenantValidationSchema(),
      onSubmit: async (values) => {
        handleCreateConvenantSubmit(values);
      },
    }
  );

  async function handleCreateConvenantSubmit(
    request: CreateAgreementRequestDTO
  ) {
    try {
      await mutateAsync(request, {
        onSuccess: () => {
          toast({
            title: t("LABEL.success"),
            description: t("MESSAGE.created successfully"),
          });
          resetForm();
          handleClose();
        },
        onError: (error: any) => {
          toast({
            title: t("LABEL.error"),
            description: DisplayError(error, t("MESSAGE.error_message")),
            variant: "destructive",
          });
        },
      });
    } catch (error) {
      toast({
        title: t("LABEL.error"),
        description: DisplayError(error, t("MESSAGE.error_message")),
        variant: "destructive",
      });
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-10 px-4 pb-8">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-zinc-700">Novo Convênio</h2>
        <Button
          type="button"
          variant="outline"
          onClick={() => setIsImportModalOpen(true)}
          className="text-sm"
        >
          Importar CSV
        </Button>
      </div>
      <div className="space-y-2">
        <div className="flex flex-col gap-2">
          <Label>{t("LABEL.name")}</Label>
          <Input
            isInvalid={touched.name && errors.name}
            isValid={touched.name && !errors.name}
            {...getFieldProps("name")}
            messageError={errors.name}
          />
        </div>
        <div className="flex flex-col gap-2">
          <Label>{t("LABEL.phone")}</Label>
          <Input
            inputPhone
            isInvalid={touched.phone && errors.phone}
            isValid={touched.phone && !errors.phone}
            {...getFieldProps("phone")}
            messageError={errors.phone}
          />
        </div>
        {/*
        <div className="flex flex-col gap-2">
          <Label>{t("LABEL.comission")} (%)</Label>
          <Input
            type="number"
            isInvalid={touched.commission && errors.commission}
            isValid={touched.commission && !errors.commission}
            {...getFieldProps("commission")}
            messageError={errors.commission}
          />
        </div>
        */}
      </div>
      <Button isLoading={isLoading} className="w-full">
        {t("LABEL.save")}
      </Button>
      
      <ImportAgreementModal
        isOpen={isImportModalOpen}
        onClose={() => setIsImportModalOpen(false)}
        onSuccess={handleClose}
      />
    </form>
  );
}
